import { Environment } from './environment-interface';

// Note - this is the "base" environment - certain properties are overridden in environment.prod
export const baseEnvironment: Environment = {
	production: false,
	deployInfo: {
		version: '26.6.26.1',
	},
};
